import { ComponentType } from '../../registries/types/propTypes';
import { Video, BrightcoveVideo } from '../../../components/VideoSection/types/propsTypes';
import type { VideoSectionProps } from '../../../components/VideoSection/VideoSection';
import { CMSTransformerDataType } from '../../types/common';
import { ImageDefination } from '../../../components/types/common';

const transformVideoSection = (data: CMSTransformerDataType): VideoSectionProps => {
  const videoSectionData = Array.isArray(data?.video_section) ? data?.video_section[0] : data?.video_section;
  const videoType = videoSectionData?.video_type;
  const videoUrl =
    videoType == Video.upload && videoSectionData?.video
      ? videoSectionData?.video.url
      : videoSectionData?.video_url?.href;
  const title = videoSectionData?.title;

  const images: ImageDefination[] = videoSectionData?.thumbnail?.images?.map((item: CMSTransformerDataType) => {
    const image = {
      url: item.image.url,
      altText: item.alt_text,
      viewport: item.viewport,
    };
    return image;
  });

  let brightcove: BrightcoveVideo | undefined;
  if (videoType == Video.brightcove) {
    const brightcoveData = Array.isArray(videoSectionData?.brightcove)
      ? videoSectionData?.brightcove[0]
      : videoSectionData?.brightcove;

    brightcove = {
      videoId: brightcoveData?.id,
      poster: brightcoveData?.images?.poster?.src ?? '',
      accountId: brightcoveData?.account_id,
    };
  }

  return {
    componentType: ComponentType.video_section,
    videoType,
    videoUrl,
    title,
    brightcove,
    images,
  };
};

export default transformVideoSection;
